import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { forgotPassword } from "../../services/auth.service";
import { toast } from "react-toastify";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch } from "react-redux";

const ForgotPassword = (props) => {
  const [input, setInput] = useState();
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear validation error for the current field
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!input.email) {
      newErrors.email = "Email is required";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (localStorage.getItem("emailForForget")) {
        // If it exists, clear the existing value
        localStorage.removeItem("emailForForget");
      }

      localStorage.setItem("emailForforget", input.email);
      await dispatch(setLoader(true));
      try {
        const res = await forgotPassword(input);
        // setLoading(true);
        if (res?.data?.status === true) {
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.setOtpModal(true);
          props.setForgotPasswordModal(false);
          await dispatch(setLoader(false));
        } else {
          toast.warning(res.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          await dispatch(setLoader(false));
        }
      } catch (e) {
        await dispatch(setLoader(false));

        console.log("error", e);
      } finally {
        // Set loading back to false when API call completes
        await dispatch(setLoader(false));

        // setLoading(false);
      }
    }
  };

  return (
    <>
      <Modal
        size="sm"
        show={props.forgotPasswordModal}
        onHide={() => props.setForgotPasswordModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Forgot Password</h2>
          <div className="modal-sub-title">
            Welcome to Helpr! We are here to help with your
            <br /> service requests.
          </div>
          <Form
            className="modal-form-wrapper"
            onSubmit={(e) => handleSubmit(e)}
          >
            <Form.Group className="mb-4" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your registered email"
                name="email"
                onChange={(e) => handleChange(e)}
              />
            </Form.Group>
            {errors.email && (
              <span style={{ color: "red" }}>{errors.email}</span>
            )}

            <Form.Group className="mb-4">
              <div className="d-grid">
                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  onClick={handleSubmit}
                  disabled={!input}
                >
                  Submit
                </Button>
              </div>
            </Form.Group>
            <div
              className="form-footer text-center w-100 mb-2"
              onClick={() => {
                props.setSignUpModal(true);
                props.setForgotPasswordModal(false);
              }}
            >
              Back to login? <span>Login page</span>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ForgotPassword;
